import axios from "axios";
import store from "@/store";
import Notice from "view-design/src/components/notice";
import _this from "@/main";
import Cookies from "js-cookie";
import { clear } from 'idb-keyval'

let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;
let removePending = config => {
  for (let p in pending) {
    if (!/dashboards/.test(_this.$route.name)) {
      let eventAnalysis =
        /\/api\/events\/report\//.test(pending[p].u) &&
        pending[p].u === config.url + "&" + config.method; //事件分析
      let propertyAnalysis =
        /\/api\/user\/properties\/report\//.test(pending[p].u) &&
        pending[p].u === config.url + "&" + config.method; //属性分析
      if (eventAnalysis || propertyAnalysis) {
        //当当前请求在数组中存在时执行函数体,仅对report进行拦截
        pending[p].f(); //执行取消操作
        pending.splice(p, 1); //把这条记录从数组中移除
      }
    } else {
      //切换概览列表时，取消上一个概览的获取分析数据的请求
      if (
        /\/api\/events\/report\//.test(pending[p].u) &&
        /\/api\/dashboard\/items\//.test(config.url) &&
        config.method === "get"
      ) {
        pending[p].f(); //执行取消操作
        pending.splice(p, 1); //把这条记录从数组中移除
      }
    }
  }
};

class HttpRequest {
  // 每个类都必须有的
  constructor(baseUrl = baseURL) {
    this.baseUrl = baseUrl;
  }

  getRequestConfig() {
    const token = store.state.user.userInfo.token;
    const userId = store.state.user.userInfo.userId;
    const config = {
      baseURL: this.baseUrl,
      headers: {
        userId: Cookies.get("userId"),
        token: Cookies.get("token")
      }
    };
    return config;
  }

  httpRequestConfig() {
    const token = store.state.user.userInfo.token;
    const userId = store.state.user.userInfo.userId;
    const config = {
      baseURL: this.baseUrl,
      headers: {
        "Content-Type": "application/json",
        userId: Cookies.get("userId"),
        token: Cookies.get("token")
      }
    };
    return config;
  }

  uploadRequestConfig() {
    //上传请求
    const token = store.state.user.token;
    const userId = store.state.user.userId;
    const config = {
      baseURL: this.baseUrl,
      headers: {
        "Content-Type": "application/json",
        userId: Cookies.get("userId"),
        token: Cookies.get("token")
      }
    };
    return config;
  }

  // 拦截器拦截请求
  interceptors(instance) {
    // 请求拦截器
    instance.interceptors.request.use(
      config => {
        removePending(config); //在一个ajax发送前执行一下取消操作
        config.cancelToken = new cancelToken(c => {
          // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
          pending.push({ u: config.url + "&" + config.method, f: c });
        });
        if (
          Object.prototype.toString.call(config.data) !== "[object FormData]" &&
          config.data !== undefined
        ) {
          // FormData数据不能转成字符串，必须是对象
          config.data = encodeURIComponent(JSON.stringify(config.data)); //发送之前统一编码
        }
        store.commit("SET_REQUESTS", pending);
        console.log(config, 'config')
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );

    // 响应拦截器
    instance.interceptors.response.use(
      res => {
        removePending(res.config); // 在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除

        const { data } = res;
        // if (data.status === 0) {
        if (data.status === -1001001) {
          Notice.error({ title: "登录信息失效，请重新登录" });
          store.commit("logout", _this);
          _this.$router.push("/view/login");

          store.commit("clearOpenedSubmenu");
          localStorage.clear()
          clear()
          var cookies = Cookies.get();

          for (var cookieName in cookies) {
            Cookies.remove(cookieName);
          }
        } else if (data.status === -1002001) {
          _this.$Message.warning("用户没有权限");
        } else if (data.status === -1004001) {
          _this.$Message.warning("密码错误");
        } else if (data.status === -1004002) {
          _this.$Message.warning("帐户未注册");
        } else if (data.status === -11000001) {
          _this.$Message.warning("不允许修改属性");
        } else if (data.status === -11000002) {
          _this.$Message.warning("属性值错误");
        } else if (data.status === -11000003) {
          _this.$Message.warning("错误的域名");
        } else if (data.status === -11000004) {
          _this.$Message.warning("域名与证书不匹配");
        } else if (data.status === -11000023) {
          _this.$Message.warning("重复的域名");
        } else if (data.status === -11000005) {
          _this.$Message.warning("平台名不能为空");
        } else if (data.status === -11000006) {
          _this.$Message.warning("错误的CPU核数，必须是整数");
        } else if (data.status === -11000007) {
          _this.$Message.warning("错误的CPU核数限制，必须是整数");
        } else if (data.status === -11000008) {
          _this.$Message.warning("错误的部署时间，必须符合时间格式");
        } else if (data.status === -11000009) {
          _this.$Message.warning("错误的事件数量，必须是整数");
        } else if (data.status === -11000010) {
          _this.$Message.warning("错误的事件限制数，必须是整数");
        } else if (data.status === -11000011) {
          _this.$Message.warning("错误的内存数，必须是整数");
        } else if (data.status === -11000012) {
          _this.$Message.warning("错误的内存限制，必须是整数");
        } else if (data.status === -11000013) {
          _this.$Message.warning("错误的节点数，必须是整数");
        } else if (data.status === -11000014) {
          _this.$Message.warning("错误的节点数限制，必须是整数");
        } else if (data.status === -11000015) {
          _this.$Message.warning("错误的项目数，必须是整数");
        } else if (data.status === -11000016) {
          _this.$Message.warning("错误的项目数限制，必须是整数");
        } else if (data.status === -11000017) {
          _this.$Message.warning("错误的结束时间，不符合时间格式");
        } else if (data.status === -11000018) {
          _this.$Message.warning("错误的用户数，必须是整数");
        } else if (data.status === -11000019) {
          _this.$Message.warning("错误的用户数限制，必须是整数");
        } else if (data.status === -11000020) {
          _this.$Message.warning("错误的版本号");
        } else if (data.status === -11000021) {
          _this.$Message.warning("错误的证书");
        } else if (data.status === -11000022) {
          _this.$Message.warning("错误的证书密钥");
        }
        console.log(data, 'datadata')
        return data;
      },
      error => {
         return Promise.reject(error);
      }
    );
  }

  httpRequest(options) {
    // 普通请求
    const instance = axios.create();
    options = Object.assign(this.httpRequestConfig(), options); // 数据拼接 相同的数据后面覆盖前面
    this.interceptors(instance);
    return instance(options);
  }

  getRequest(options) {
    const url = options.url;
    const params = options.params;

    const instance = axios.create(this.getRequestConfig());
    this.interceptors(instance);
    return instance.get(url, { params });
  }

  uploadRequest(options) {
    const instance = axios.create();
    options = Object.assign(this.uploadRequestConfig(), options); // 数据拼接 相同的数据后面覆盖前面
    this.interceptors(instance);
    return instance(options);
  }
}

export default HttpRequest;



// WEBPACK FOOTER //
// ./src/libs/axios.js